module.exports = __webpack_public_path__ + "static/media/hero.d15183cb.jpg";